import { OEP_PARTICIPANT_ROLE_KEYS, OEP_ROLE_LABELS, PublishedResources, type IOEPResource, type IOEPRoleResources, type OEPRoleKey } from 'agu_oep_core';

/** Implementer copy: a role the user holds whose Season.Resources list is empty or missing. */
export const OEP_NO_GUIDANCE = 'No guidance has been published for this role yet.';
/** markup.html:913 verbatim. */
export const OEP_RESOURCES_SUB = "Only the guidance for roles you actually hold, so nobody wonders why they're reading committee instructions.";

export interface OEPResourceGroup { Role: OEPRoleKey; Window: string; Items: readonly IOEPResource[] }

/**
 * One group per role the user holds (markup.html:917-931, logic.js:765): participant roles in
 * OEP_PARTICIPANT_ROLE_KEYS order, staff last. Window is the role's "opens" copy.
 */
export function BuildResourceGroups(roles: ReadonlySet<OEPRoleKey>, resources: IOEPRoleResources): OEPResourceGroup[] {
    const order: OEPRoleKey[] = [...OEP_PARTICIPANT_ROLE_KEYS, 'staff'];
    // Presenter links still on the placeholder Url are hidden even when this view is reached by link (client edit 2026-10-27).
    const items = (r: OEPRoleKey): readonly IOEPResource[] => (r === 'presenter' ? PublishedResources(resources[r] ?? []) : (resources[r] ?? []));
    return order.filter((r) => roles.has(r)).map((r) => ({ Role: r, Window: OEP_ROLE_LABELS[r].Opens, Items: items(r) }));
}
